<template>
  <p v-if="q.question_type == 'file_upload' && q.answer.file_uploads[0] !== undefined" class="mb-0"><i>{{q.prompt}}</i>:<strong><a :href="q.answer.file_uploads[0].url" target="_blank"> {{q.answer.file_uploads[0].file_name}}</a></strong></p>
  <p v-else-if="q.question_type == 'check_box'" class="mb-0"><i>{{q.prompt}}</i>:<strong> {{q.answer.value.filter(val => val !== "0").join(", ")}}</strong></p>
  <p v-else-if="q.question_type == 'long_text'" class="mb-0"><i>{{q.prompt}}</i>:<strong> <br> {{q.answer.value}}</strong></p>
  <h5 v-else-if="q.question_type == 'instructions'" class="mb-0"><strong>{{q.prompt}}</strong></h5>
  <p v-else class="mb-0"><i>{{q.prompt}}</i>:<strong> {{q.answer.value}}</strong></p>
</template>

<script>

export default {
  props:{
    q: Object
  },
  components:{
  },
  data(){
    return{
      
    }
  },
  methods:{

  },
  mounted(){
  }
}
</script>

<style lang="scss" scoped>

H5 {
  font-family: 'Barlow Semi Condensed', sans-serif;
  font-size: 20px;
  font-weight: 600;
}

</style>
